<template>
  <div class="d-flex flex-column gap-4">
    <box-node>
      <div class="d-flex flex-column gap-2">
        <span class="font-weight-medium">Hipótese diagnóstica</span>
        <div v-if="!!hypothesis" class="d-flex flex-row gap-1 align-center">
          <span class="font-size-22">{{ hypothesis.text }}</span>
          <template v-if="!!hypothesis.helperText">
            <span class="font-size-14 text-muted">•</span>
            <span class="font-size-14 text-muted">{{ hypothesis.helperText }}</span>
          </template>
        </div>
        <span v-else class="font-size-22">-</span>
      </div>
    </box-node>

    <medicine-prescription v-model="treatmentsPosologies" :treatmentsWarnings="treatmentsWarnings" />
  </div>
</template>

<script>
import { Computed, ObjectLiteral } from '@/_typedefs'
import { WatchOptionsWithHandler } from 'vue'
import BoxNode from '@/components/NewAttendanceForm/FormNodes/Box/BoxNode.vue'
import MedicinePrescription from './Prescription/MedicinePrescription.vue'
import { createNamespacedHelpers } from 'vuex'

const {
  mapMutations: newAttendanceFormMutations,
  mapActions: newAttendanceFormActions,
  mapGetters: newAttendanceFormGetters,
} = createNamespacedHelpers('newAttendanceForm')

export default {
  components: {
    BoxNode,
    MedicinePrescription,
  },
  props: {
    treatmentsWarnings: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      /** @type {{text: string; helperText?: string}?} */
      hypothesis: null,
      /** @type {Record<number, string>} */
      treatmentsPosologies: {},
      unwatch: null,
    }
  },
  computed: {
    .../** @type {{parameters: Computed<ObjectLiteral>, extraAnswers: Computed<ObjectLiteral>}} */ (
      newAttendanceFormGetters(['parameters', 'extraAnswers'])
    ),
  },
  methods: {
    ...newAttendanceFormMutations(['updateExtraAnswer']),
    ...newAttendanceFormActions(['getParameter', 'getExtraAnswer']),
  },
  watch: {
    /** @type {WatchOptionsWithHandler<Record<number, string>>} */
    treatmentsPosologies: {
      handler(value) {
        this.updateExtraAnswer({ name: 'indicated-treatments', value })
      },
      deep: true,
    },
  },
  created() {
    this.hypothesis = this.parameters['asthma:hypothesis']?.label ?? {}
    this.treatmentsPosologies = this.extraAnswers['indicated-treatments'] ?? {}

    this.unwatch = this.$store.subscribe((mutation) => {
      if (mutation.type !== 'newAttendanceForm/updateParameter') {
        return
      }
      const { parameter, value } = mutation.payload
      if (parameter !== 'asthma:hypothesis') {
        return
      }

      this.hypothesis = value?.label
    })
  },
  beforeDestroy() {
    this.unwatch?.()
  },
}
</script>

<style scoped></style>
